import React, { lazy } from 'react';

// 演示版路由
const LoginForRobot = lazy(() => import('@/pages/robotForActivity/Login'));
const RobotHome = lazy(() => import('@/pages/robotForActivity/Home'));
const PsychologicalAIConsultantWithPrompt = lazy(() => import('@/pages/robotForActivity/PsychologicalAIConsultation/PsychologicalAIConsultantWithPrompt'));
const PsychologicalAIConsultant = lazy(() => import('@/pages/robotForActivity/PsychologicalAIConsultation'));
const PsychologicalAIAssistant = lazy(() => import('@/pages/robotForActivity/PsychologicalAIConsultation/PsychologicalAIAssistant'));
const PsychologicalAIEvaluation = lazy(() => import('@/pages/robotForActivity/PsychologicalAIConsultation/PsychologicalAIEvaluation'));
const ConsultationSummary = lazy(() => import('@/pages/robotForActivity/ConsultationSummary'));


const robotRoutes = [
  { path: '/robot-activity/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/robot-activity/home', component: <RobotHome />, needInterceptor: true },
  { path: '/robot-activity/psychological-ai-consultant-with-prompt', component: <PsychologicalAIConsultantWithPrompt />, needInterceptor: true },
  { path: '/robot-activity/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/robot-activity/psychological-ai-assistant', component: <PsychologicalAIAssistant />, needInterceptor: true },
  { path: '/robot-activity/psychological-ai-evaluation', component: <PsychologicalAIEvaluation />, needInterceptor: true },
  { path: '/robot-activity/consultation-summary', component: <ConsultationSummary />, needInterceptor: false },
];

export default robotRoutes;
